import React, { useEffect } from 'react'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import { makeStyles } from '@material-ui/core'
import { useGlobalState } from '../../providers/GlobalState'

interface ScenariosButtonProps {
  handleScenarioChange(url: string): void
}

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: 10,
    left: 10
  },
  optionsMenu: {
    display: 'flex',
    padding: 0
  },
  option: {
    borderRadius: 0,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4
  }
}))

const ScenariosButton: React.FC<ScenariosButtonProps> = ({
  handleScenarioChange
}) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const [activeUrl, setSelectedUrl] = React.useState<string>('')
  const { scenes } = useGlobalState()

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    url: string
  ) => {
    setSelectedUrl(url)
    handleScenarioChange(url)
    setOpen(false)
    localStorage.setItem(
      'scenario',
      JSON.stringify(scenes.find(x => x?.thumb === url))
    )
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  useEffect(() => {
    const sceneStorage = localStorage.getItem('scenario')
    if (scenes && scenes[0]) {
      if (sceneStorage) {
        const { thumb, cacheKey } = JSON.parse(sceneStorage)
        if (scenes.find(x => x?.cacheKey === cacheKey)) {
          setSelectedUrl(thumb)
          handleScenarioChange(thumb)
        } else {
          setSelectedUrl(scenes[0].thumb)
          handleScenarioChange(scenes[0].thumb)
        }
      } else {
        setSelectedUrl(scenes[0].thumb)
        handleScenarioChange(scenes[0].thumb)
      }
    } else {
      setSelectedUrl('./snellen.png')
      handleScenarioChange('./snellen.png')
    }
  }, [scenes])

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }

    setOpen(false)
  }

  if (scenes && scenes[0] !== null) {
    return (
      <div className={classes.root}>
        <ButtonGroup
          variant="contained"
          color="primary"
          ref={anchorRef}
          aria-label="split button"
        >
          <Button>
            {scenes.find(x => x?.thumb === activeUrl)?.name || ''}
          </Button>
          <Button
            color="primary"
            size="small"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
            className="notDraggable"
          >
            <ArrowRightIcon />
          </Button>
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="right"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'left' ? 'right' : 'center left'
              }}
            >
              <Paper className={classes.option}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    id="split-button-menu"
                    className={classes.optionsMenu}
                  >
                    {scenes.map(option => {
                      if (option) {
                        return (
                          <MenuItem
                            key={option.name}
                            selected={option?.thumb === activeUrl}
                            className="notDraggable"
                            onClick={event =>
                              handleMenuItemClick(event, option.thumb)
                            }
                          >
                            {option.name}
                          </MenuItem>
                        )
                      } else {
                        return ''
                      }
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    )
  }
  return <></>
}

export default ScenariosButton
